import isGHMC, {
  getCurrentDate,
  getCurrentDateTime,
  getStartOfCurrentDate,
} from "./../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect } from "react";
import { DetailedReportTSSCTPExport } from "./DetailedReportTSSCTPExport";
import { TransferstationManagementStore } from "./store/transferstationManagementStore";

export const TransferstationMonthlyFilters = () => {
  const { fetchTransferstationManagementReport, transferstationManagementReportData } = TransferstationManagementStore();
  const isProd = isGHMC();
  const currentDate = getCurrentDate();

  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0];
  };

  // Default values without using localStorage
  const defaultValues = {
    FromDate: currentDate,
    ToDate: currentDate,
  };

  const handleSubmit = (values) => {
    fetchTransferstationManagementReport(values);
  };

  useEffect(() => {
    fetchTransferstationManagementReport(defaultValues);
  }, []);

  return (
    <Formik initialValues={defaultValues} enableReinitialize onSubmit={handleSubmit}>
      {({ values }) => (
        <Form>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-end gap-2 mb-2">
              {/* From Date */}
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">From Date</label>
                  <Field
                    type="date"
                    id="FromDate"
                    name="FromDate"
                    className="form-control bg-white"
                    min={values.ToDate && getLast30DaysDate(values.ToDate)} // optional last 30 days
                    max={values.ToDate || currentDate} // cannot be after To Date
                    required
                  />
                </div>
              </div>

              {/* To Date */}
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="date"
                    id="ToDate"
                    name="ToDate"
                    className="form-control bg-white"
                    min={values.FromDate} // cannot be before From Date
                    max={currentDate}      // cannot be after today
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
              >
                Search
              </button>
            </div>

            <div className="mt-4 d-flex">
              <DetailedReportTSSCTPExport data={transferstationManagementReportData} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
